import React from "react";

const CatalogueTitle = ({ title, titleText, titleImage, ...props }) => {
  return (
    <div style={{ width: "100%", overflowX: "hidden" }}>
      <div className="row">
        <div className="col-12">
          <p
            className="container-title"
            style={{
              textAlign: "left",
              marginBottom: "1rem",
              fontFamily: "Felix Titling",
              fontWeight: "600",
              color: "#285979",
              padding: "1rem 1rem 0rem 1rem ",
            }}
          >
            {title}
          </p>
          <p
            style={{
              textAlign: "left",
              marginBottom: "1.5rem",
              padding: "0rem 1rem 0rem 1rem ",
              color: "#285979",
              fontFamily: "Raleway",
            }}
          >
            {titleText}
          </p>
        </div>
      </div>

      {/* --- Banner image hidden temporarily ---
      {titleImage && (
        <div className="row">
          <div className="col-12" style={{ padding: "0rem 1rem" }}>
            <img
              src={titleImage}
              style={{
                width: "100%",
                maxHeight: "200px",
                height: "auto",
                objectFit: "contain",
                borderRadius: "6px",
                display: "block",
              }}
              alt={`${title || "collection"}`}
            />
          </div>
        </div>
      )}
      --- End hidden banner --- */}
    </div>
  );
};

export default CatalogueTitle;
